// extracted by mini-css-extract-plugin
export var danger = "_40-6";
export var lightPink = "_40-a";
export var medium = "_40-j";
export var nearSquare = "_40-m";
export var neutralBlue = "_40-8";
export var neutralYellow = "_40-7";
export var noCapitalize = "_40-1";
export var normal = "_40-2";
export var pill = "_40-0";
export var primary = "_40-3";
export var primaryLight = "_40-4";
export var shadow = "_40-n";
export var small = "_40-k";
export var solidBlack = "_40-i";
export var solidGreen = "_40-d";
export var solidLightBlue = "_40-f";
export var solidNavy = "_40-e";
export var solidOrange = "_40-h";
export var solidPink = "_40-g";
export var solidRed = "_40-b";
export var solidWhite = "_40-9";
export var solidYellow = "_40-c";
export var success = "_40-5";
export var xsmall = "_40-l";